"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Config = void 0;
var config_1 = require("./config");
exports.Config = config_1.default;
